import { lazy } from 'react';

/** Открывает форму тега */
export const TagFormPageAsync = lazy(() => import('./TagForm/TagFormPage'));
